module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: ("" + (_vm.isDisabled ? 'checkbox is-disabled' : 'checkbox'))
  }, [(_vm.name !== '') ? [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.onSelect
    }
  })] : [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.onSelect
    }
  })], _vm._v(" "), _c('icon', {
    staticClass: "checkbox__icon",
    attrs: {
      "name": "check",
      "height": "12",
      "width": "12"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99020e1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormInput.vue
// module id = 1057
// module chunks = 1